import * as Turbo from '@hotwired/turbo';
import Scrollbar from 'smooth-scrollbar';
import Cookies from 'js-cookie'; // https://github.com/js-cookie/js-cookie
import Litepicker from 'litepicker'; // https://github.com/wakirin/Litepicker

import('./bootstrap');
import('./elements/turbo-echo-stream-tag');

import {createPopper} from '@popperjs/core';

import {Application} from 'stimulus'
import {definitionsFromContext} from '@stimulus/webpack-helpers'

const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))


Turbo.start();

// Always show progress bar
Turbo.setProgressBarDelay(0);

document.addEventListener("turbo:before-cache", function () {

	if ($('.slick-initialized').length) {
		$('.slick-initialized').slick('unslick');
	}

	if ($('.session-calendar').length) {
		$(".session-calendar").datepicker("destroy");
	}

})


document.addEventListener("turbo:load", function () {

	//console.log('turbo:load', Math.random());
	pageLoadJs();
});

document.addEventListener("turbo:before-visit", function () {

	if ($('#mobile-slide-nav:visible').length) {
		$('#mobile-slide-nav').slideUp(200);
	}
});

function pageLoadJs() {

	pageLoadCount++;

	var animatedDotsTimer = null;

	// Using GTM triggers instead now
	//gtag('config', gaId, {'page_path': window.location.pathname});

	//console.log('page-load-ga', gaId, window.location.pathname);


	if (typeof (document.querySelector('#vertical-menu nav')) != 'undefined' && document.querySelector('#vertical-menu nav') != null) {
		Scrollbar.init(document.querySelector('#vertical-menu nav'), {
			"alwaysShowTracks": true,
			"continuousScrolling": false
		});
	}

	/*
	Scrollbar.init(document.querySelector('#content, #app.no-menu'), {
		"alwaysShowTracks": false
	});
	 */
	//Scrollbar.initAll();

	$(function () {

		var disablePopupBodyScroll = false;

		// Clear any no-scroll added by open menus
		$('body, html').removeClass('no-scroll');

		// Button location aware hover
		/*
		$('.btn')
			.on('mouseenter !touchstart', function (e) {
				var parentOffset = $(this).offset(),
					relX = e.pageX - parentOffset.left,
					relY = e.pageY - parentOffset.top;
				$(this).find('.hover').css({top: relY, left: relX})
			})
			.on('mouseout', function (e) {
				var delta = 30;
				var height = $(this).height();
				var width = $(this).width();
				//console.log(width, height);

				var parentOffset = $(this).offset(),
					relX = e.pageX - parentOffset.left,
					relY = e.pageY - parentOffset.top;

				$(this).find('.hover').css({top: relY, left: relX})
			});
		*/


		function animated_dots() {
			clearInterval(animatedDotsTimer);
			var dots = 1;
			animatedDotsTimer = setInterval(function () {
				dots++;
				if (dots > 3) {
					dots = 1;
					$(".dots").text(".");
				}
				if (dots === 2) {
					$(".dots").text("..");
				}
				if (dots === 3) {
					$(".dots").text("...");
				}
			}, 500);
		}

		if ($(".dots").length) {
			animated_dots();
		}


		/**
		 * Select 2
		 */
		$("select[data-plugin='select2-with-search']").select2({
			escapeMarkup: function (text) {
				return text;
			}
		});
		$("select[data-plugin='select2-no-search']").select2({
			minimumResultsForSearch: -1,
			escapeMarkup: function (text) {
				return text;
			}
		});


		// Force a quick tough to trigger a full hover animation
		$('.btn, a').on('touchstart click', function () {
			$(this).addClass('active');
			var that = this;
			setTimeout(function () {
				$(that).removeClass('active');
			}, 300);
		})

		// Analytics event when clicking booking link
		$('#session-picker .booking-link').click(function () {
			analyticsEvent('Outbound Link Click', 'Booking Link', $(this).attr('data-event'));
		});
		$('#session-picker .reference-link').click(function () {
			analyticsEvent('Outbound Link Click', 'Reference Link', $(this).attr('data-event'));
		});

		// Search event
		if ($('#search-form input[name=s]').length && $('#search-form input[name=s]').val()) {
			analyticsEvent('view_search_results', 'Search', $('#search-form input[name=s]'));
		}

		// Mobile nav slider
		$('#mobile-nav-button').click(function (e) {
			e.preventDefault();

			if ($('#mobile-slide-nav:visible').length) {
				// Close
				$('#mobile-slide-nav').slideUp(200);
				$('#mobile-nav-button .fa-bars').css('display', 'block');
				$('#mobile-nav-button .fa-times').hide();
				$('body, html').removeClass('no-scroll');
				$(window).trigger('resize');
			} else {
				// Open
				$('#mobile-slide-nav').slideDown(200);
				$('#mobile-nav-button .fa-bars').hide();
				$('#mobile-nav-button .fa-times').css('display', 'block');
				$('body, html').addClass('no-scroll');
				$(window).trigger('resize');
			}
		});

		$('.nav-close').click(function (e) {
			e.preventDefault();
			$('#mobile-nav-button').trigger('click');
		});

		if ($('.featured-carousel').length) {

			$('.featured-carousel').slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				centerMode: true,
				variableWidth: true,
				swipeToSlide: true,
				prevArrow: '<button type="button" class="slick-prev"><img src="/images/left-white.svg" /></button>',
				nextArrow: '<button type="button" class="slick-next"><img src="/images/right-white.svg" /></button>',
			});
			$('.featured-carousel').addClass('fade-in');
		}

		if ($('.event-strip-carousel').length) {

			// Don't init all carousels at once as this causes redraw/popin issues
			// which don't look nice. Instead delay initializing each by sleepInterval
			var sleepInterval = 100;
			var sleep = sleepInterval;

			$('.event-strip-carousel').each(function () {
				var self = this
				setTimeout(function () {

					var slickConfig = {
						fade: false,
						dots: false,
						infinite: false,
						speed: 300,
						slidesToShow: 1,
						centerMode: false,
						variableWidth: true,
						swipeToSlide: true,
						rows: $(self).hasClass('announced-strip') ? 2 : 1,
						prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
						nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
					};
					if ($(self).hasClass('announced-strip')) {
						slickConfig.responsive = [
							{
								breakpoint: 768,
								settings: {
									rows: 1
								}
							}
						];
					}
					$(self).slick(slickConfig);

				}, sleep)
				sleep += sleepInterval;
			});
		}

		if ($('.filter-strip-carousel').length) {
			$(".filter-strip-carousel").slick({
				fade: false,
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				centerMode: false,
				variableWidth: true,
				swipeToSlide: true,
				rows: 1,
				prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
				nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
			});
		}

		// Price / date filter buttons
		if ($('.price-filter-button').length) {
			filterDropdown('.price-filter-button', '.price-filter-dropdown');
		}
		if ($('.date-filter-button').length) {
			filterDropdown('.date-filter-button', '.date-filter-dropdown');
		}
		if ($('.price-filter-button2').length) {
			filterDropdown('.price-filter-button2', '.price-filter-dropdown2');
		}
		if ($('.date-filter-button2').length) {
			filterDropdown('.date-filter-button2', '.date-filter-dropdown2');
		}

		function filterDropdown(button, tooltip) {
			var buttonEl = document.querySelector(button);
			var tooltipEl = document.querySelector(tooltip);
			$(tooltip).hide();

			$(button).click(function () {
				if ($(tooltip + ':visible').length) {
					$(tooltip).slideUp();
					$(button).removeClass('open');
				} else {
					$(tooltip).css('min-width', $(button).outerWidth());
					$(tooltip).slideDown('fast');
					$(button).addClass('open');
					var popper = createPopper(buttonEl, tooltipEl, {
						placement: 'bottom-start',
						modifiers: [
							{
								name: 'offset',
								//isolation: 'isolate',
								options: {
									offset: [0, 8],
								},
							},
						],
					});
				}
			});

			$(document).on('click', function (e) {
				var target = $(e.target);
				if (
					!target.is(button) &&
					!target.is(button + ' i') &&
					!target.is(tooltip) &&
					!target.is(tooltip + ' .filter-row') &&
					!target.is(tooltip)
				) {
					$(tooltip).slideUp();
					$(button).removeClass('open');
				}
			});
		}

		$('#find-tickets-btn').click(function (e) {
			e.preventDefault();

			$([document.documentElement, document.body]).animate({
				scrollTop: $("#session-picker").offset().top
			}, 1000);
		});

		/*
		if ($('#session-picker').length) {
			$(window).scroll(function () {

				if (!$("#session-picker").length) {
					return;
				}

				var scroll = $(window).scrollTop() + $(window).height();
				if (scroll > $("#session-picker").offset().top) {
					$("#find-tickets-btn").fadeOut();
				} else {
					$("#find-tickets-btn").show();
				}
			})
		}
		 */

		$('#session-picker input[name="venue"]').change(function () {
			var selector = '#' + $(this).val();
			if (!$(selector + ':visible').length) {
				$('.session-step-2').slideUp();
				$('.session-step-3').slideUp();
				$(selector).slideDown();

				$('.session-step-2 .ui-state-active').removeClass('ui-state-active');

				// If it only has one date also open step 3
				if ($(selector).attr('data-date-count') === "1") {
					//$('.session-step-3[data-event="'+ $(this).val() +'"]').slideDown();
				}
			}
		});


		/**
		 * Youtube popup
		 */
		$(".play-youtube").click(function () {
			var videoId = $(this).attr("data-videoid");
			if (videoId) {
				playYoutube(videoId);
			}
		});
		/*
		$("#video-container").click(function () {
			closeVideoPopup();
		});

		 */
		var youtubeReady = false;

		function onYouTubeIframeAPIReady() {
			youtubeReady = true;
		}

		var playYoutube = function (videoId) {

			if (!youtubeReady || typeof YT != "undefined") {
				//return false;
			}

			var selectorId = "video-" + videoId;
			// Don't replace video if it's already embeded so playback can continue
			if (!$("#" + selectorId).length) {
				$("#video-container .video").html("<div class='videoWrapper'><div  id='" + selectorId + "'></div></div>");
				youtubeVideo = new YT.Player(selectorId, {
					height: '390',
					width: '640',
					frameborder: 0,
					videoId: videoId,
					playerVars: {
						rel: 0,
						showinfo: 0
					},
					events: {
						'onReady': onPlayerReady,
						//'onStateChange': onPlayerStateChange
					}
				});
			} else {
				youtubeVideo.playVideo();
			}
			//$("#video-container").fadeIn();
			openVideoPopup("#video-container");
			$(window).trigger("resize");

		};

		/*
		function closeVideoPopup() {
			closePopup();
			if (youtubeVideo) {
				youtubeVideo.pauseVideo();
			}
		}

		 */

		$(".popouter, .popinner").click(function (e) {
			if (e.target !== this) {
				return;
			}


			closePopup();
		});

		function openPopup(id) {
			if (id) {
				disablePopupBodyScroll = true;
				$(id).fadeIn();
				$("body").css("overflow-y", "hidden");
			}
		}

		function closePopup() {
			$(".popouter").fadeOut();
			$("body").css("overflow-y", "");
			$("body").css("overflow-x", "");
			$("body").removeClass("popup-is-open");
			disablePopupBodyScroll = false;

			// Kill YT
			if (youtubeVideo) {
				youtubeVideo.pauseVideo();
			}
		}

		var youtubeVideo = false;

		function youtubeApi() {
			var tag = document.createElement('script');
			tag.src = "https://www.youtube.com/iframe_api";
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		};

		function onPlayerReady(event) {
			event.target.playVideo();
		}

		function openVideoPopup(id) {
			if (id) {
				disablePopupBodyScroll = true;

				$(id).fadeIn();
				$("body").css("overflow-y", "hidden");
			}
		}

		youtubeApi();

		$(".favme").click(function (e) {
			e.preventDefault();
			toggleFavorite($(this).attr('data-event'), $(this).attr('data-city'));
		});

		/**
		 * What's on when
		 */
		$('#change-when').click(function(e) {
			e.preventDefault();
			openPopup('#select-when');
		});

		/**
		 * Custom date range popup
		 */
		var datePickerBaseUrl = '?';
		$("#open-custom-date-range, .open-custom-date-range").click(function (e) {
			e.preventDefault();
			closePopup();
			openPopup('#custom-date-range')

			datePickerBaseUrl = $(this).attr('href');
		});
		//$("#open-custom-date-range").trigger('click');

		if ($("#date-range").length) {
			var minDate = new Date();
			minDate.setDate(minDate.getDate() - 1);
			const picker = new Litepicker({
				element: document.getElementById('date-range'),
				inlineMode: true,
				minDate: minDate,
				singleMode: false,
				autoApply: false,
				format: "YYYY-MM-DD",
				startDate: typeof startDateLocal != 'undefined' ? startDateLocal : null,
				endDate: typeof endDateLocal != 'undefined' ? endDateLocal : null,
				setup: (picker) => {
					picker.on('button:cancel', () => {
						closePopup();
					});
					picker.on('button:apply', (date1, date2) => {
						if (date1 == null && date2 == null) {
							return;
						}

						var urlParams = new URLSearchParams({
							startdate: date1 ? formatDate(date1) : '',
							enddate: date2 ? formatDate(date2) : '',
						});

						var url =  urlParams.toString();
						if (typeof datePickerBaseUrl !== 'undefined') {
							url = datePickerBaseUrl + url;
						}
						else if (typeof customDateBaseUrl !== 'undefined') {
							url = customDateBaseUrl + url;
						}

						Turbo.visit(url);
					});
				},
			});
		}

		$('.filter-strip-carousel .item a, .date-filter-dropdown a').click(function () {
			var title = $(this).text().trim();
			analyticsEvent('Filter', 'Date', title);
			console.log('Filter click', title);
		});

		$('.price-filter-dropdown a').click(function () {
			var title = $(this).text().trim();
			analyticsEvent('Filter', 'Price', title);
			console.log('Filter click', title);
		});


		/**
		 * Convert date object to YYYY-MM-DD
		 * @param date
		 * @returns {string}
		 */
		function formatDate(date) {
			// Just in case I pass in a string like the dork I am
			if (typeof date == 'object') {
				var d = date;
			} else {
				var d = new Date(date);
			}

			var month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

			if (month.length < 2)
				month = '0' + month;
			if (day.length < 2)
				day = '0' + day;

			return [year, month, day].join('-');
		}


		function setFavorite(id) {
			$(".favme[data-id='" + id + "'] i").removeClass('fal');
			$(".favme[data-id='" + id + "'] i").addClass('fas');
			$(".favme[data-id='" + id + "']").addClass('faved');
		}

		function toggleFavorite(event_id, city_id) {


			var formData = new FormData();
			formData.append('event_id', event_id);
			formData.append('city_id', city_id);

			$.ajax({
				headers: {
					'X-CSRF-TOKEN': _token
				},
				url: shortlistAjax,
				type: 'POST',
				data: formData,
				processData: false,  // tell jQuery not to process the data
				contentType: false,  // tell jQuery not to set contentType
				error: function (jqXHR, json) {
					console.log('favourite error', json);
				},
				success: function (data) {
					//console.log(data);

					if (data.showLoginPopup) {
						$('#favourite-login-pop-container').fadeIn();
					}

					var id = data.city + '-' + data.event;

					if (data.added) {
						analyticsEvent("Favourite", "Event", data.eventSlug);

						$(".favme[data-id='" + id + "'] i").removeClass('fal');
						$(".favme[data-id='" + id + "'] i").addClass('fas');
						$(".favme[data-id='" + id + "']").addClass('faved');
					}

					if (data.removed) {
						$(".favme[data-id='" + id + "'] i").removeClass('fas');
						$(".favme[data-id='" + id + "'] i").addClass('fal');
						$(".favme[data-id='" + id + "']").removeClass('faved');
					}
				}
			});
		}


		if ($("#title-outer").length && $("#main-title").length) {
			$(document).scroll(function () {
				if ($("#main-title").offset() == undefined) {
					return false;
				}


				var scrollPosition = window.scrollY;
				var titleTop = $("#main-title").offset().top + $("#main-title").height();

				if (scrollPosition >= titleTop) {
					$("#title-outer").fadeIn(500);
					$('.publish-event-btn').css('display', 'none');
				} else {
					$("#title-outer").fadeOut(500);
					$('.publish-event-btn').css('display', '');
				}
			});
		}

		if ($(".filter-strip-carousel-container").length && !$(".filter-strip-carousel-outer.full").length) {
			$(document).scroll(function () {

				if (!$(".filter-strip-carousel-container").length || $(".filter-strip-carousel-outer.full").length) {
					return;
				}

				if ($(window).width() > 768) {
					var padding = 15;
				} else {
					var padding = 25;
				}


				var scrollPosition = window.scrollY;
				var filterTop = $(".filter-strip-carousel-outer").offset().top - padding;

				if (scrollPosition >= filterTop) {
					$(".filter-strip-carousel-container").addClass('fixed');
					$('.publish-event-btn').css('display', 'none');
				} else {
					$(".filter-strip-carousel-container").removeClass('fixed');
					$('.publish-event-btn').css('display', '');
				}
			});
		}

		if ($(".whats-on-title-container").length) {
			$(document).scroll(function () {

				if (!$(".whats-on-title-container").length) {
					return;
				}

				if ($(window).width() > 768) {
					var padding = 15;
				} else {
					var padding = 25;
				}


				var scrollPosition = window.scrollY;
				var filterTop = $(".whats-on-title-container-outer").offset().top - padding;
				var outerHeight = $(".whats-on-title-container-outer").height();

				if (scrollPosition >= filterTop) {
					$(".whats-on-title-container").addClass('fixed');
					$('.publish-event-btn').css('display', 'none');
					$(".whats-on-title-container-outer").height(outerHeight);
				} else {
					$(".whats-on-title-container").removeClass('fixed');
					$('.publish-event-btn').css('display', '');
					$(".whats-on-title-container-outer").css('height', '');
				}
			});
		}

		if ($('.cover-image').length) {
			$(window).resize(function () {
				$('.cover-image .static-bg').height($('.cover-image').innerHeight());
			});
		}

		/**
		 * Anchor links
		 */
		$('a[href*=\\#]').on('click', function (e) {

			var anchor = $(this).attr('href');

			if (anchor.length > 1 && $(anchor).length) {
				e.preventDefault();
				$([document.documentElement, document.body]).animate({
					scrollTop: $(anchor).offset().top
				}, 700);
			}

		});


		$('#hide-newsletter-bar').click(function (e) {
			e.preventDefault();
			var url = $(this).attr('data-url');
			console.log(url);

			$.ajax({
				headers: {
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				type: "POST",
				url: url,
				data: {},
				success: function (data) {
					console.log('hide-newsletter-bar', data);
				}
			});

			$('#newsletter-bar').slideUp();
			return false;
		});

		$('#hide-suggest-city-notification, #ignore-suggest-city-notification').click(function (e) {
			e.preventDefault();
			var url = $(this).attr('data-url');
			console.log(url);

			$.ajax({
				headers: {
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				type: "POST",
				url: url,
				data: {},
				success: function (data) {
					console.log('hide-suggest-city-bar', data);
				}
			});

			$('#suggest-city-notification').slideUp();
			return false;
		});


		$("#hide-change-city-notification").click(function (e) {
			e.preventDefault();
			$('#change-city-notification').slideUp();
		});


		/**
		 * Download app popup
		 */
		$('.popouter .close, .popouter .skip').click(function (e) {
			e.preventDefault();
			closePopup();
		});
        /*
		if ($('#download-app-container').length && !isApp && !Cookies.get('shownDownloadPop') && deviceType() != 'desktop') {

			console.log('download-app-popup', deviceType(), Math.random(), Cookies.get('shownDownloadPop'), pageLoadCount);

			if (pageLoadCount > 1 && !Cookies.get('shownDownloadPop')) {
				setTimeout(function () {
					$('#download-app-container').fadeIn();
					Cookies.set('shownDownloadPop', true, {expires: 7}); // Hide for 1 week
				}, 30000);

			}
		}
         */

		/**
		 * Login popup
		 */
		if ($('#login-pop-container').length && !Cookies.get('shownLoginPop')) {
			setTimeout(function () {
				$('#login-pop-container').fadeIn();
				Cookies.set('shownLoginPop', true, {expires: 1}); // Hide for 1 day
			}, 20000);
		}


		/**
		 * Replace submit button with loading spinner while form submits since
		 * hotwire turbo doesn't display the loading bar during these types of requests :-(
		 */
		$("form").submit(function () {
			if ($(this).has(".loading-spinner-here")) {
				var btn = $(this).find(".loading-spinner-here");
				var currentWidth = btn.width();
				if (btn.has(".btn-white")) {
					var imgName = 'bars-black.svg';
				} else {
					var imgName = 'bars.svg';
				}
				btn.html("<span class='svg-loader' style='width: " + currentWidth + "px;'><img src='/svg-loaders/" + imgName + "'></span>");
				//$(this).find(".loading-spinner-here").css('width', currentWidth +'px');
				//btn.css('opacity', 0.7);
				btn.prop('disabled', true);
			}
		});

		/*
		if ($(".cover-image .static-bg").length) {
			$(document).scroll(function() {
				if ($(".mobile-header:visible").length) {
					$(".cover-image .static-bg").removeClass('scrolled');
				}
				var scrollPosition = window.scrollY;
				var scrollPast = $(".mobile-header").innerHeight();

				//console.log('scrollPosition', scrollPosition);
				//console.log('scrollPast', scrollPast);

				if (scrollPosition >= scrollPast) {
					$(".cover-image .static-bg").addClass('scrolled');
					//console.log('lock');
				}
				else {
					$(".cover-image .static-bg").removeClass('scrolled');
					//console.log('unlock');
				}
			});
		}
		 */
		/**
		 * Fadeout featured image as the user scrolls down the page
		 */
		if ($(".static-bg").length && $('.cover-image').length) {
			window.addEventListener("scroll", () => {
				var currentScroll = window.pageYOffset;

				var coverHeight = $('.cover-image').innerHeight();
				var wait = coverHeight * 0.1;
				var start = coverHeight + wait;
				var checkpoint = coverHeight - wait;

				var vector = (currentScroll - wait) / (checkpoint * 0.9);

				if (vector < 0) {
					vector = 0;
				}

				var opacity = 1;
				if (currentScroll >= wait) {
					opacity = 1 - vector;
				}

				document.querySelector(".static-bg").style.setProperty('opacity', opacity, 'important');
				document.querySelector(".static-bg").style.setProperty('animation', 'none'); // Without this opacity doesn't work on IOS/MAC

				if ($('.critic-portrait').length) {
					document.querySelector(".critic-portrait").style.setProperty('opacity', opacity, 'important');
					document.querySelector(".critic-portrait").style.setProperty('animation', 'none'); // Without this opacity doesn't work on IOS/MAC
				}

				//console.log(coverHeight, wait, start, checkpoint, vector, currentScroll, opacity);
			});
		}

		/**
		 * Menu top right
		 */
		$('#header-right-menu a.main').click(function (e) {
			e.preventDefault();

			var id = $(this).attr('id');
			var target = $('nav.dropdown[for=' + id + ']');
			if ($(this).hasClass('open')) {
				$(this).removeClass('open');
				target.slideUp();
			} else {
				$(this).addClass('open');
				target.slideDown();
			}
		});
		$(document).on("click", function (event) {
			var trigger = $("#header-right-menu a.main")[0];
			var trigger2 = $("#header-right-menu a.main i")[0];
			var dropdown = $("nav.dropdown");
			if (dropdown !== event.target && !dropdown.has(event.target).length && (trigger !== event.target && trigger2 !== event.target)) {
				$("#header-right-menu a.main").removeClass('open');
				$("nav.dropdown").slideUp();
			}
		});

		// Resize funkyness
		$(window).resize(function () {
			// Close mobile nav if it changes to desktop size
			if (!$('#mobile-nav:visible').length && $('#mobile-slide-nav:visible').length) {
				$('#mobile-slide-nav').hide();
				$('#mobile-nav-button .fa-bars').css('display', 'block');
				$('#mobile-nav-button .fa-times').hide();
				$('body, html').removeClass('no-scroll');
			}

			if (!$('#header-right-menu:visible').length) {
				$('#header-right-menu .main').removeClass('open');
				$('#header-right-menu nav.dropdown').hide();

			}

			if ($('.featured-carousel')) {
				$('.featured-carousel .item').css('max-width', window.innerWidth);
			}

			if ($('#short-list-page.critic').length) {
				if ($('#vertical-menu:visible').length) {
					$(".critic-info-outer").css('height');
				} else {
					$(".critic-info-outer").css('height', $('.cover-image ').outerHeight());
				}
			}
		});

		$(window).trigger('resize');
		$(document).trigger('scroll');
	});
}

/*
(function() {
    const buttons = document.querySelectorAll(".btn");

    buttons.forEach(button => {
        ["mouseenter", "mouseout"].forEach(evt => {
            button.addEventListener(evt, e => {
                let parentOffset = button.getBoundingClientRect(),
                    relX = e.pageX - parentOffset.left,
                    relY = e.pageY - parentOffset.top;

                const span = button.getElementsByTagName("span");

                span[0].style.top = relY + "px";
                span[0].style.left = relX + "px";
            });
        });
    });
})();
*/

